import { createIcons, Home, ChevronRight, ChevronDown, Building2, Award, Users, Star, Clock, Shield, ShieldCheck, Zap, FileText } from "lucide";

export default class AboutSidebar {
  constructor() {
    // Support both old and new selectors
    this.sidebar = document.querySelector(".js-corporate-sidebar") || document.querySelector(".js-about-sidebar");
    this.toggle  = document.querySelector(".js-corporate-toggle") || document.querySelector(".js-about-sidebar-toggle");
    this.menu    = document.querySelector(".js-corporate-nav") || document.querySelector(".js-about-menu");

    if (!this.sidebar || !this.toggle || !this.menu) return;

    createIcons({
      icons: { Home, ChevronRight, ChevronDown, Building2, Award, Users, Star, Clock, Shield, ShieldCheck, Zap, FileText }
    });

    this.bind();
  }

  bind() {
    this.toggle.addEventListener("click", () => {
      const isOpen = this.menu.classList.toggle("is-open");
      this.toggle.classList.toggle("is-open", isOpen);
      this.toggle.setAttribute("aria-expanded", String(isOpen));
    });

    const MQ = 1024; // Changed to match lg breakpoint
    const onResize = () => {
      if (window.innerWidth >= MQ && this.menu.classList.contains("is-open")) {
        this.menu.classList.remove("is-open");
        this.toggle.classList.remove("is-open");
        this.toggle.setAttribute("aria-expanded", "false");
      }
    };
    window.addEventListener("resize", onResize);
  }
}
